export default __webpack_public_path__ + "static/pexels-pixabay-209961-6a8ffc62f798719f6fac9ba41de50031.jpg";